import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FiLogOut, FiSettings, FiUser } from 'react-icons/fi';
import { useAuth } from '../context/AuthContext';
import './UserMenu.css';

export function useLogout() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  return useCallback(() => {
    logout();
    navigate('/login', { replace: true });
  }, [logout, navigate]);
}

export default function UserMenu() {
  const { user } = useAuth();
  const handleLogout = useLogout();
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onPointer = (e) => {
      if (rootRef.current?.contains(e.target)) return;
      setOpen(false);
    };
    const onKey = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('pointerdown', onPointer);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('pointerdown', onPointer);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  const close = () => setOpen(false);

  return (
    <div className="user-menu" ref={rootRef}>
      <button
        type="button"
        className="user-menu-trigger"
        aria-label="Account menu"
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        <span className="user-menu-avatar">{user?.initials || 'AB'}</span>
      </button>

      {open ? (
        <div className="user-menu-panel" role="menu">
          <div className="user-menu-head">
            <span className="user-menu-head-avatar">{user?.initials || 'AB'}</span>
            <div className="user-menu-head-text">
              <span className="user-menu-head-name">{user?.name || user?.username || 'User'}</span>
              {user?.email ? (
                <span className="user-menu-head-email">{user.email}</span>
              ) : null}
            </div>
          </div>
          <div className="user-menu-divider" />
          <Link
            to="/profile"
            role="menuitem"
            className="user-menu-item"
            onClick={close}
          >
            <span className="user-menu-item-icon" aria-hidden>
              <FiUser />
            </span>
            <span className="user-menu-item-label">Profile</span>
          </Link>
          <Link
            to="/settings"
            role="menuitem"
            className="user-menu-item"
            onClick={close}
          >
            <span className="user-menu-item-icon" aria-hidden>
              <FiSettings />
            </span>
            <span className="user-menu-item-label">Settings</span>
          </Link>
          <div className="user-menu-divider" />
          <button
            type="button"
            role="menuitem"
            className="user-menu-item user-menu-item-danger"
            onClick={() => {
              close();
              handleLogout();
            }}
          >
            <span className="user-menu-item-icon" aria-hidden>
              <FiLogOut />
            </span>
            <span className="user-menu-item-label">Log out</span>
          </button>
        </div>
      ) : null}
    </div>
  );
}
